import {AgentResourceFrame} from './agent_resource_frame.js'

export const AgentSkillsFrame = {
  mounted() {
    AgentResourceFrame.mounted.call(this)
    this.onMessage = event => {
      if (event.origin !== window.location.origin || event.source !== this.el.contentWindow) return
      if (event.data?.type === "seiva:close-agent-skills") this.pushEvent("close_agent_skills", {})
    }
    window.addEventListener("message", this.onMessage)
  },
  destroyed() {
    window.removeEventListener("message", this.onMessage)
    AgentResourceFrame.destroyed.call(this)
  }
}

export const AgentSkillsReturn = {
  mounted() {
    this.handleEvent("close_agent_skills_frame", () => {
      if (window.parent !== window) {
        window.parent.postMessage({type: "seiva:close-agent-skills"}, window.location.origin)
      }
    })
  }
}
